import { createErpContext } from "./createErpContext"
import {
  contabilidad,
  contactos,
  crear,
  documentos,
  globals,
  importar,
  inventario,
  misEmpresas,
  notifications,
  ocr,
  tesoreria,
  user,
  validaciones,
} from "./initialStates"

const { ContextProvider, useGlobalContext } = createErpContext({
  globals,
  contabilidad,
  contactos,
  crear,
  documentos,
  importar,
  inventario,
  misEmpresas,
  notifications,
  ocr,
  tesoreria,
  user,
  validaciones,
})

export { ContextProvider, useGlobalContext }
